import { CheckCircle2, AlertTriangle, Clock, Circle, ShieldCheck, Info, AlertOctagon } from "lucide-react";

const READINESS = {
  "Not started": { cls: "bg-gray-100 text-gray-700 border-gray-200", Icon: Circle },
  "In progress": { cls: "bg-ltblue text-tblue border-tblue/30", Icon: Clock },
  "Action needed": { cls: "bg-amber-50 text-[#B47500] border-brandyellow/50", Icon: AlertTriangle },
  "Under review": { cls: "bg-purple-50 text-purple-700 border-purple-200", Icon: Clock },
  "Ready for submission": { cls: "bg-emerald-50 text-emerald-700 border-emerald-300", Icon: CheckCircle2 },
};

const SEVERITY = {
  Information: { cls: "bg-ltblue text-tblue border-tblue/30", Icon: Info },
  Attention: { cls: "bg-amber-50 text-[#B47500] border-brandyellow/50", Icon: AlertTriangle },
  "High attention": { cls: "bg-orange-50 text-coral border-coral/40", Icon: AlertTriangle },
  "Critical review": { cls: "bg-red-50 text-red-700 border-red-300", Icon: AlertOctagon },
};

const DOC_STATUS = {
  Uploaded: "bg-gray-100 text-gray-700 border-gray-200",
  "Security checked": "bg-ltblue text-tblue border-tblue/30",
  Processing: "bg-amber-50 text-[#B47500] border-brandyellow/40",
  Extracted: "bg-emerald-50 text-emerald-700 border-emerald-300",
  "Needs review": "bg-orange-50 text-coral border-coral/40",
  Reviewed: "bg-emerald-50 text-emerald-700 border-emerald-300",
  Failed: "bg-red-50 text-red-700 border-red-300",
};

export function ReadinessBadge({ state, size = "sm", testId }) {
  const cfg = READINESS[state] || READINESS["Not started"];
  const pad = size === "lg" ? "px-3.5 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
  return (
    <span data-testid={testId || "readiness-badge"}
      className={`inline-flex items-center gap-2 rounded-md border font-medium ${cfg.cls} ${pad}`}>
      <span className="h-1.5 w-1.5 rounded bg-current" aria-hidden /> {state}
    </span>
  );
}

export function SeverityBadge({ severity, testId }) {
  const cfg = SEVERITY[severity] || SEVERITY.Information;
  return (
    <span data-testid={testId || "severity-badge"}
      className={`inline-flex items-center gap-2 rounded-md border px-2.5 py-1 text-xs font-medium ${cfg.cls}`}>
      <span className="h-1.5 w-1.5 rounded bg-current" aria-hidden /> {severity}
    </span>
  );
}

export function DocStatusBadge({ status }) {
  const cls = DOC_STATUS[status] || DOC_STATUS.Uploaded;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded border px-2.5 py-1 text-xs font-medium ${cls}`} data-testid="doc-status-badge">
      {status}
    </span>
  );
}

export function AvailabilityBadge({ availability }) {
  const map = {
    Available: "bg-emerald-50 text-emerald-700 border-emerald-300",
    Pilot: "bg-ltblue text-tblue border-tblue/40",
    "Coming soon": "bg-gray-100 text-gray-600 border-gray-200",
  };
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-xs font-semibold ${map[availability] || map["Coming soon"]}`} data-testid="availability-badge">
      {availability}
    </span>
  );
}
